import { getDbSupabase } from './supabase';
import type { DemItem } from '../types/dem';

type CitPowerBiItemsResponse = {
  items?: Array<Partial<DemItem> & { code?: string }>;
  error?: string;
};

function toDemItem(row: Partial<DemItem> & { code?: string }): DemItem | null {
  const code = String(row.code ?? '').trim();
  if (!code) return null;
  return {
    code,
    description: String(row.description ?? '').trim(),
    uom: String(row.uom ?? '').trim(),
    packing: String(row.packing ?? '').trim(),
    image_url: String(row.image_url ?? '').trim(),
    is_blocked: Boolean(row.is_blocked),
    inventory: Number(row.inventory ?? 0) || 0,
    stock_status: String(row.stock_status ?? '').trim(),
    chinese_description: String(row.chinese_description ?? '').trim(),
    status: String(row.status ?? 'Active').trim() || 'Active',
  };
}

/** Search PowerBI purchasing.item_list (full master, no DEM sync filters). */
export async function searchCitPowerBiItems(
  query: string,
  limit = 25,
): Promise<DemItem[]> {
  const headers: Record<string, string> = { Accept: 'application/json' };
  try {
    const { data } = await getDbSupabase().auth.getSession();
    const token = data.session?.access_token?.trim();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch {
    // proxy rejects unauthenticated
  }

  const params = new URLSearchParams({
    search: query.trim(),
    limit: String(Math.min(Math.max(limit, 1), 50)),
  });
  const response = await fetch(`/cit-items-api?${params.toString()}`, { headers });
  const json = (await response.json().catch(() => null)) as CitPowerBiItemsResponse | null;
  if (!response.ok) {
    throw new Error(json?.error || `Item search failed (${response.status})`);
  }
  return (json?.items ?? [])
    .map((row) => toDemItem(row))
    .filter((row): row is DemItem => Boolean(row));
}
